import { useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import Grid from '@mui/material/Grid';
import OwnerDropDownSearch from './UserDropDownSearch';
import ApproverDropDownSearch from './UserDropDownSearch';
import {
  STRATEGY_APPROVER_TOOLTIP,
  STRATEGY_OWNER_TOOLTIP
} from '../shared/AppConstants';

export default function StrategyOverview(props) {
  const {
    ownerObj,
    ownerDefaultValue,
    masterOwnerUserList,
    masterApproverUserList,
    control,
    approverDefaultValue,
    readOnly,
    commonProps,
    isEdit,
    viewOverView,
    selectedOverviewViewList,
    isNewForm,
    setIsStrategyOverviewDirty
  } = props;

  useEffect(() => {
    if (selectedOverviewViewList) {
      commonProps.setValue('ownerId', selectedOverviewViewList.ownerId ?? '', {
        shouldValidate: true
      });
      commonProps.setValue(
        'approverId',
        selectedOverviewViewList.approverId ?? '',
        { shouldValidate: true }
      );
    }
  }, [selectedOverviewViewList]);

  return (
    <Box sx={(theme) => ({ mt: theme.fuel6Tokens.JddcSpacingMedium })}>
      <Card>
        <CardContent>
          <Box>
            <Box id="strategyOverview">
              <Grid container alignItems="flex-start">
                <Grid size={8}>
                  <Grid container alignItems="center" columnGap={1}>
                    {!isNewForm && isEdit && (
                      <IconButton
                        aria-label="edit"
                        onClick={(e) => viewOverView(e)}
                        sx={(theme) => ({
                          borderRadius: theme.fuel6Tokens.JddcRadiusSmall,
                          flexShrink: 0,
                          ...(isEdit && { bgcolor: 'action.selected' })
                        })}
                      >
                        <fuel-icon name="edit" />
                      </IconButton>
                    )}
                    {!isNewForm && (
                      <Typography
                        variant="h3"
                        sx={{ display: 'flex', alignItems: 'center' }}
                      >
                        {isEdit && (
                          <Box
                            component="span"
                            sx={(theme) => ({
                              color: theme.fuel6Tokens.JddcColorTextSecondary
                            })}
                          >
                            (Edit Mode)
                          </Box>
                        )}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid container alignItems="flex-start" spacing={2}>
                <Grid size={{ xs: 12, md: 6 }} fullWidth>
                  <Grid container alignItems="center">
                    <Typography variant="h3">
                      Strategy Owner{' '}
                      <Box
                        component="span"
                        aria-label="required field"
                        sx={{ color: 'error.main' }}
                      >
                        *
                      </Box>
                    </Typography>
                    <Tooltip title={STRATEGY_OWNER_TOOLTIP}>
                      <IconButton
                        aria-label="Strategy owner information"
                        size="small"
                      >
                        <fuel-icon name="info" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid>
                    <OwnerDropDownSearch
                      key={ownerObj}
                      isError={commonProps.errors.ownerId ? 'danger' : ''}
                      rules={{ required: true }}
                      readOnly={readOnly}
                      control={control}
                      name="ownerId"
                      defaultValue={ownerDefaultValue}
                      masterUserList={masterOwnerUserList}
                      register={commonProps.register}
                      commonProps={commonProps}
                      customOnChangeHandler={setIsStrategyOverviewDirty}
                      runCustomOnChangeHandler
                    />
                  </Grid>
                  {commonProps.errors.ownerId && (
                    <Typography variant="labelSmall" color="error">
                      This is a required field!
                    </Typography>
                  )}
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} fullWidth>
                  <Grid container alignItems="center">
                    <Typography variant="h3">
                      Strategy Approver{' '}
                      <Box
                        component="span"
                        aria-label="required field"
                        sx={{ color: 'error.main' }}
                      >
                        *
                      </Box>
                    </Typography>
                    <Tooltip title={STRATEGY_APPROVER_TOOLTIP}>
                      <IconButton
                        aria-label="Strategy approver information"
                        size="small"
                      >
                        <fuel-icon name="info" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid>
                    <ApproverDropDownSearch
                      key={ownerObj}
                      isError={commonProps.errors.approverId ? 'danger' : ''}
                      rules={{ required: true }}
                      readOnly={readOnly}
                      control={control}
                      name="approverId"
                      defaultValue={approverDefaultValue}
                      masterUserList={masterApproverUserList}
                      register={commonProps.register}
                      commonProps={commonProps}
                      customOnChangeHandler={setIsStrategyOverviewDirty}
                      runCustomOnChangeHandler
                    />
                  </Grid>
                  {commonProps.errors.approverId && (
                    <Typography variant="labelSmall" color="error">
                      This is a required field!
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
